import { render, staticRenderFns } from "./PermissionListTab.vue?vue&type=template&id=9df42b3c&"
import script from "./PermissionListTab.vue?vue&type=script&lang=js&"
export * from "./PermissionListTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9df42b3c')) {
      api.createRecord('9df42b3c', component.options)
    } else {
      api.reload('9df42b3c', component.options)
    }
    module.hot.accept("./PermissionListTab.vue?vue&type=template&id=9df42b3c&", function () {
      api.rerender('9df42b3c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/employee/permission/permission-list/PermissionListTab.vue"
export default component.exports